import React, { useState, useEffect } from "react";

// User-Daten mit Bildern und PINs
const USERS = {
    Rasmus: { pin: "1111", image: "/assets/Logo.png" },
    Silas: { pin: "2222", image: "/assets/logo1.png" },
    Jokim: { pin: "3333", image: "/assets/logo2.png" },
    Talika: { pin: "2002", image: "/assets/logo3.png" },
    Caroline: { pin: "1571", image: "/assets/logo4.png" },
    Katja: { pin: "1234", image: "/assets/logo5.png" },
    Janika: { pin: "2002", image: "/assets/logo6.png" },
    Kiara: { pin: "8888", image: "/assets/logo7.png" },
    Max: { pin: "9999", image: "/assets/logo8.png" },
    Culbin: { pin: "1010", image: "/assets/logo9.png" },
    Lena: { pin: "1212", image: "/assets/logo10.png" },
    Stefan: { pin: "1313", image: "/assets/logo11.png" }
};

const API_URL = "https://reise-2026-backend.rasmus-schindler.workers.dev";
const authToken = "secret-token"; 
const POLLING_INTERVAL = 120000;  // 2 Minuten statt 60 Sekunden
function UserListe({ name }) {
    const [input, setInput] = useState("");
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const username = sessionStorage.getItem("username"); 

    // --- NEUER useEffect HOOK MIT POLLING ---
    useEffect(() => {
        let isMounted = true; // Prevents updating state on an unmounted component (memory leak cleanup)
        let isFirstLoad = true;

        const fetchList = async () => {
            // Loading-Status nur beim allerersten Laden setzen
            if (isFirstLoad) {
                setLoading(true);
                isFirstLoad = false;
            }
            setError(null);
            
            try {
                const response = await fetch(`${API_URL}/lists/${name}`, {
                    headers: {
                        "Authorization": `Bearer ${authToken}`, 
                        "Content-Type": "application/json"
                    }
                });

                if (!response.ok) {
                    const errData = await response.json().catch(() => ({}));
                    throw new Error(`HTTP-Fehler ${response.status}: ${errData.error || response.statusText}`);
                }
                const data = await response.json();
                
                if (isMounted) {
                    setList(Array.isArray(data) ? data : []);
                    setLoading(false);
                }
            } catch (error) {
                console.error("Polling-Fehler:", error);
                if (isMounted) {
                    // Show a temporary error but keep polling
                    setError(`Load failed: ${error.message || 'Netzwerkverbindung fehlgeschlagen.'}`);
                    setLoading(false); 
                }
            }
        };

        // 1. Initialer Load beim Mounten
        fetchList(); 
        
        // 2. Start des Polling-Intervalls
        const intervalId = setInterval(fetchList, POLLING_INTERVAL); 

        // 3. Cleanup-Funktion: Wird beim Unmounten ausgeführt, um das Intervall zu stoppen
        return () => {
            isMounted = false;
            clearInterval(intervalId);
        };
    }, [name, error, list.length]); // Alle Abhängigkeiten hinzugefügt

    // --- HINZUFÜGEN (handleAdd) ---
    // Nach Hinzufügen/Löschen wird die Liste NEU vom Server abgerufen.
    // Da Polling aktiv ist, wird die UI sowieso in 5s aktualisiert, aber wir können es sofort triggern.
    const handleAdd = () => {
        if (!input) return;
        setLoading(true);
        setError(null);
        
        fetch(`${API_URL}/lists/${name}`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${authToken}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ entry: input })
        })
        .then(res => {
            if (!res.ok) throw new Error(`HTTP-Fehler: ${res.status}`);
            return res.json();
        })
        .then(data => {
            setList(Array.isArray(data) ? data : []);
            setInput("");
            setLoading(false);
        })
        .catch(error => {
            console.error("Fehler beim Hinzufügen:", error);
            setError(`Add failed: ${error.message}`);
            setLoading(false);
        });
    };

    // --- LÖSCHEN (handleDelete) ---
    const handleDelete = (index) => {
        setLoading(true);
        setError(null);
        
        fetch(`${API_URL}/lists/${name}/${index}`, {
            method: "DELETE",
            headers: {
                "Authorization": `Bearer ${authToken}`,
                "Content-Type": "application/json"
            }
        })
        .then(res => {
            if (!res.ok) throw new Error(`HTTP-Fehler: ${res.status}`);
            return res.json();
        })
        .then(data => {
            setList(Array.isArray(data) ? data : []);
            setLoading(false);
        })
        .catch(error => {
            console.error("Fehler beim Löschen:", error);
            setError(`Delete failed: ${error.message}`);
            setLoading(false);
        });
    };

    // --- RENDERING (Unchanged) ---
    return (
        <React.Fragment>
            <div className="dasbaorlistaround personlist userlistbox">
                <div className="image">
                    <img src={USERS[name]?.image || "/assets/Logo.png"} alt={name} />
                </div>
                <div style={{ flex: 1 }}>
                    <h5 className="name">{name}</h5>
                    {/* Status-Anzeigen */}
                    {loading && list.length === 0 && <p></p>} 
                    {error && <p style={{ color: "red" }}>Fehler: {error}</p>}
                    
                    {/* Liste mit sanften Übergängen */}
                    {!error && (
                        <ul style={{
                            transition: "all 0.3s ease-in-out",
                            opacity: loading ? 0.7 : 1
                        }}>
                            {list.map((item, i) => (
                                <li key={i} style={{ 
                                    display: "flex", 
                                    alignItems: "center", 
                                    gap: "0.5rem",
                                    transition: "all 0.3s ease-in-out"
                                }}>
                                    {item}
                                    {/* Löschen nur für den eigenen User erlaubt */}
                                    {username === name && (
                                        <button 
                                            className="delite" 
                                            onClick={() => handleDelete(i)} 
                                            style={{ marginLeft: 8 }}
                                            disabled={loading}
                                        >
                                            x
                                        </button>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}

                    {/* Hinzufügen-Formular */}
                    {username === name && (
                        <form onSubmit={e => { e.preventDefault(); handleAdd(); }} style={{ display: "flex", gap: "0.5rem" }}>
                            <input
                                className="newlistitem"
                                value={input}
                                onChange={e => setInput(e.target.value)}
                                placeholder="Neuer Eintrag..."
                                disabled={loading}
                            />
                            <button className="addbutton" type="submit" disabled={loading || !input}>Hinzufügen</button>
                        </form>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
}

export default UserListe;
